import { getRequiredMessage } from '@monetize/types/common';
import * as z from 'zod';
import { TenantStatusEnum } from './enums.types';
import { IUser, UserStatusEnum } from './user.types';

export const TenantEntitlementsSchema = z.object({
  cpqEnabled: z.boolean(),
  billingEnabled: z.boolean(),
  reportingEnabled: z.boolean(),
  dataExportEnabled: z.boolean(),
  invoiceTransformationsEnabled: z.boolean(),
  usageCustomFieldsEnabled: z.boolean(),
});

export type ITenantEntitlements = z.infer<typeof TenantEntitlementsSchema>;

export const TenantSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  timezone: z.string(),
  testTenant: z.boolean(),
  isAdmin: z.boolean(),
  status: z.enum(TenantStatusEnum),
  entitlements: TenantEntitlementsSchema.nullish(),
});

export const TenantRequestSchema = TenantSchema.pick({
  description: true,
  timezone: true,
  testTenant: true, // BE ignores this on update requests
}).extend({
  name: z.string().min(1, getRequiredMessage('Name')),
});

export type TenantRequest = z.infer<typeof TenantRequestSchema>;

export type ITenant = z.infer<typeof TenantSchema>;

export interface TenantUserMap {
  tenant: ITenant;
  user: Omit<IUser, 'roles' | 'teams' | 'status'>;
  status: UserStatusEnum;
}
